import React, { HTMLAttributes } from 'react';
import * as styles from '../../styles/nvIcons.module.scss';

const ContactIcon: React.FC<HTMLAttributes<HTMLElement>> = (props) => (
  <i {...props} className={`${props.className} ${styles.nv_icon_phone}`}></i>
);

export default ContactIcon;
